module.exports = __webpack_public_path__ + "static/media/icon-edition.31bae336.svg";